<template>
    <div class="left_panel">
        <div
            class="panel_head_wrap d-flex align-items-end justify-content-between"
        >
            <div class="panel_heading">
                <h2>Uploaded Images</h2>
                <div class="subhead">Manage your uploaded images</div>
            </div>
            <div
                class="panel_head_right upload_img_panel d-flex align-items-center"
            >
                <div
                    v-if="imageIds.length > 0"
                    class="select_checkbox form-check pl_8 py_6"
                >
                    <label class="checkbox_custom font_size_20"
                        >Select All
                        <input
                            type="checkbox"
                            @click="selectAll"
                            v-model="allSelected"
                        />
                        <span class="checkmark"></span>
                    </label>
                </div>
                <div
                    v-if="imageIds.length > 0"
                    @click="deleteImages()"
                    style="cursor: pointer"
                    class="delet_icon"
                >
                    <span class="bin_icon"
                        ><img
                            alt=""
                            src="/maincss/images/icons/delete_dark.svg" /></span
                    ><span class="font_size_20">Delete</span>
                </div>
            </div>
        </div>
        <!-- here we can add popup for preview images -->
        <div
            v-if="
                getUrlExtension(preview_artwork_images) != 'ai' &&
                getUrlExtension(preview_artwork_images) != 'eps'
            "
            class="modal fade cart_preview"
            id="preview_modals"
            data-backdrop="static"
            data-keyboard="false"
            tabindex="-1"
            aria-labelledby="staticBackdropLabel"
            aria-hidden="true"
        >
            <div
                class="modal-dialog modal-dialog-centered modal-xl large_popup upload_img_popup"
            >
                <div class="modal-content">
                    <div class="modal-header border-bottom-0 p-0">
                        <button
                            type="button"
                            class="close py-2 pr-3"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <img src="/maincss/images/cancel.svg" />
                        </button>
                    </div>
                    <div class="modal-body pt-0">
                        <div
                            v-if="
                                getUrlExtension(preview_artwork_images) == 'pdf'
                            "
                            class="mx-auto preview-image mb_20"
                        >
                            <iframe
                                :src="preview_artwork_images"
                                width="500px"
                                height="300px"
                            ></iframe>
                        </div>
                        <div v-else class="mx-auto preview-image mb_20">
                            <img :src="preview_artwork_images" alt="" />
                        </div>
                        <div class="mx-auto preview-image">
                            <!-- <button class="btn btn_orange bg_primary_orange text_white" type="button" @click="downloadArtwork(item.NewOrderItemDecoration ? item.NewOrderItemDecoration.final_proof_image : '', 'FinalProofImage', index)">Download</button> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="upload_img_wrap">
            <div class="row">
                <div class="col" v-if="uploadedImages.length == 0">
                    No Results found.
                </div>
                <div
                    v-for="(image, ind) in uploadedImages"
                    :key="ind"
                    class="col"
                >
                    <div class="upload_img_cont position-relative">
                        <button
                            class="add_artwork_preview_popup_btn seen"
                            data-toggle="modal"
                            data-target="#preview_modals"
                            @click="previewArtworkImages(image.image_path)"
                        >
                            <img
                                v-if="
                                    getUrlExtension(image.image_name) == 'ai' ||
                                    getUrlExtension(image.image_name) == 'eps'
                                "
                                class="download_file"
                                src="/maincss/images/download-file.svg"
                                alt="download"
                            />
                            <img
                                v-else
                                src="/maincss/images/preview.svg"
                                alt=""
                            />
                        </button>
                        <a href="#">
                            <div class="form-check pl_8 py_6">
                                <label class="checkbox_custom"
                                    ><input
                                        type="checkbox"
                                        v-model="imageIds"
                                        @click="select"
                                        :value="image.id" /><span
                                        class="checkmark"
                                    ></span
                                ></label>
                            </div>
                            <div
                                v-if="
                                    getUrlExtension(image.image_name) == 'pdf'
                                "
                                class="up_img text-center bg_primary_light_white"
                            >
                                <img src="/maincss/images/pdf.svg" />
                            </div>
                            <div
                                v-else-if="
                                    getUrlExtension(image.image_name) == 'ai'
                                "
                                class="up_img text-center bg_primary_light_white"
                            >
                                <img
                                    src="/maincss/images/ai_format_image.png"
                                />
                            </div>
                            <div
                                v-else-if="
                                    getUrlExtension(image.image_name) == 'eps'
                                "
                                class="up_img text-center bg_primary_light_white"
                            >
                                <img
                                    src="/maincss/images/eps_formate_image.png"
                                />
                            </div>
                            <div
                                v-else
                                class="up_img text-center bg_primary_light_white"
                            >
                                <img :src="image.image_path" />
                            </div>
                            <div class="up_text mt_16 ml_10 mb_40">
                                <div class="font_size_17">
                                    {{ image.image_name }}
                                </div>
                                <p class="font_size_12 text_light_grey">
                                    {{ image.image_dimension }} -
                                    {{ image.image_size }}
                                </p>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
            <b-pagination
                v-show="total_uploaded_images > 0 && item_length > itemsPerPage"
                v-model="currentPage"
                :total-rows="item_length"
                :per-page="itemsPerPage"
                class="imprint_pagination"
            ></b-pagination>
        </div>
    </div>
</template>
<script>
import ApiService from "@/common/api.service";

export default {
    name: "UploadImages",
    data() {
        return {
            uploadedImages: [],
            selected: [],
            allSelected: false,
            imageIds: [],
            searchedKeyword: "",
            listConfig: {
                searchKeyword: "",
                offset: (this.currentPage - 1) * this.itemsPerPage,
                limit: this.itemsPerPage,
                sortBy: "",
                order: "ASC",
                order_type: "all"
            },
            item_length: 0,
            currentPage: 1,
            itemsPerPage: 10,
            total_uploaded_images: 0,
            preview_artwork_images: ""
        };
    },
    computed: {
        pages() {
            if (this.item_length <= this.itemsPerPage) {
                return [1];
            }
            return [
                ...Array(Math.ceil(this.item_length / this.itemsPerPage)).keys()
            ].map((e) => e + 1);
        }
    },
    watch: {
        currentPage(newValue) {
            this.listConfig.offset = (newValue - 1) * this.itemsPerPage;
            this.UploadedImages();
        }
    },
    mounted() {
        /* eslint-disable */
        $(function () {
            $("#item2").click(function () {
                $("#submenu2").slideToggle(500);
            });
        });
        /* eslint-enable */
        var _this = this;
        _this.listConfig = {
            searchKeyword: "",
            offset: (_this.currentPage - 1) * _this.itemsPerPage,
            limit: _this.itemsPerPage,
            sortBy: "",
            order: "ASC"
        };
        _this.UploadedImages();
    },
    methods: {
        selectAll: function () {
            this.imageIds = [];

            if (!this.allSelected) {
                for (var image in this.uploadedImages) {
                    this.imageIds.push(
                        this.uploadedImages[image].id.toString()
                    );
                }
            }
        },
        select: function () {
            this.allSelected = false;
            if (this.uploadedImages.length - 1 == this.imageIds.length) {
                this.allSelected = true;
            }
        },

        UploadedImages(pagereset = false) {
            var _this = this;
            if (pagereset) {
                _this.currentPage = 1;
                _this.listConfig.offset = 0;
            }
            _this.isBusy = true;
            new Promise(() => {
                ApiService.post("/userimages", _this.listConfig)
                    .then(({ data }) => {
                        this.uploadedImages = data.userImages;
                        this.uploadedImages.forEach((image) => {
                            if (!this.isValidHttpUrl(image.image_path)) {
                                image.image_path =
                                    ApiService.apiBaseUrl() +
                                    "server" +
                                    image.image_path;
                            }
                        });
                        _this.total_uploaded_images = data.count;
                        _this.item_length = data.count;
                    })

                    .catch(({ response }) => {
                        if (response.status == 401) {
                            _this.$router.push({ name: "/client/login" });
                        }
                    });
            });
        },
        deleteImages() {
            if (confirm("Do you really want to delete?")) {
                new Promise(() => {
                    ApiService.post("/delete_userimages", {
                        ids: this.imageIds
                    })
                        .then(() => {
                            this.allSelected = false;
                            this.imageIds = [];
                            this.UploadedImages();
                            this.$toast.success("Images deleted successfully", {
                                position: "top-right"
                            });
                        })
                        .catch(({ response }) => {
                            //  console.log(response.status);
                            if (response.status == 401) {
                                this.$router.push({ name: "/client/login" });
                            }
                        });
                });
            }
        },
        isValidHttpUrl(string) {
            let url;
            try {
                url = new URL(string);
            } catch (_) {
                return false;
            }
            return url.protocol === "http:" || url.protocol === "https:";
        },
        getUrlExtension(url) {
            if (!url) {
                return false;
            }
            return url.split(/[#?]/)[0].split(".").pop().trim();
        },
        previewArtworkImages(images) {
            this.preview_artwork_images = images;
            if (
                this.getUrlExtension(images) == "ai" ||
                this.getUrlExtension(images) == "eps"
            ) {
                /* eslint-disable */
                $("#preview_modals").modal("hide");
                /* eslint-enable */
                this.downloadURI(this.preview_artwork_images, "text.eps");
                this.$toast.success("Files downloaded successfully", {
                    position: "top-right",
                    queue: true
                });
            }
        },
        downloadURI(uri, name) {
            var link = document.createElement("a");
            link.download = name;
            link.href = uri;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }
};
</script>
<style scoped>
button.add_artwork_preview_popup_btn {
    z-index: 1;
    position: relative;
}
.upload_img_cont .seen {
    left: 38%;
    top: 26%;
    position: absolute !important;
    display: none;
    border: none;
    background: #fff;
    border-radius: 12px;
}
.upload_img_cont:hover .seen {
    display: block;
}
.upload_img_cont .seen img {
    width: 50px !important;
}
</style>
